import Backbone from 'backbone';
import ko from 'knockout';
import $ from 'jquery';

import { withUiBlock } from '@bingads-webui/uiblocker';
import ViewModel from './campaignModel';
import template from './campaign.pug';
import { setPosition } from './const';

export class CampaignContextualAttributeView extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.campaignId = targetId;
    this.viewModel = new ViewModel({
      i18n,
    });
  }


  render() {
    const {
      deps,
      campaignId,
      i18n,
    } = this;

    this.$el.html(template({ i18n }));
    ko.applyBindings(this.viewModel, this.el);

    const container = this.$el.children('.contextual-tooltip-container');
    setPosition(container);

    deps.jsdata.Campaign.findAll({
      limit: 1,
      select: ['DeliveryStatus', 'CampaignType', 'Budget', 'BiddingScheme'],
      where: { Id: { $eq: campaignId } },
    }).then((response) => {
      if (response.length && response.length > 0) {
        this.viewModel.updateAttribute({
          campaignDeliveryStatus: response[0].DeliveryStatus,
          campaignType: response[0].CampaignType,
          campaignBudget: response[0].Budget ? response[0].Budget.Amount : null,
          campaignBiddingType: response[0].BiddingScheme ? response[0].BiddingScheme.Type : null,
        });
        setPosition(container);
      }
    }).finally(withUiBlock($(`.${this.el.className} .contextual-content`)));
    return this;
  }
}
